import PropTypes from 'prop-types';

import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import Avatar from '@zenbusiness/zui/Avatar';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import { VELO_AVATAR_SRC } from '../constants';
import { CANCEL_FLOW_TYPES, getCancelMessageId } from '../utils/cancelFlowConfig';

function SubscriptionCancelHelp({ cancelFlowType }) {
  const { formatMessage } = useIntl();

  return (
    <Stack horizontal alignItems="center" gap={2}>
      <Avatar
        src={VELO_AVATAR_SRC}
        alt={formatMessage({ id: 'dashboard.subscriptionCancel.help.avatarAlt' })}
        sx={{ width: 40, height: 40 }}
      />
      <Text size="md" color="secondary">
        <FormattedMessage id={getCancelMessageId(cancelFlowType, 'help')} />
      </Text>
    </Stack>
  );
}

SubscriptionCancelHelp.propTypes = {
  cancelFlowType: PropTypes.oneOf(Object.values(CANCEL_FLOW_TYPES)).isRequired,
};

export default SubscriptionCancelHelp;
